'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {List} from '../../../components/lists/List';
import {ListDivider} from '../../../components/lists/ListDivider';
import {getCollection, getId} from '../../../core-utilities/domain/ReduxUtils';
import {getMessagesFromProps, I18nComponent} from '../../../core-utilities/react-i18n';
import {getItemClass} from '../../../core-utilities/redux/utils';
import {responsiveContent} from '../../../core-utilities/responsive-components/ResponsiveContentHOC';
import {
  ASSET_FILE_REQUIREMENT_COLLECTION,
  ASSET_FORM_REQUIREMENT_COLLECTION,
  FILE_REQUIREMENT_COLLECTION,
  FORM_REQUIREMENT_COLLECTION,
} from '../../domain/config';
import {SUB_HEADER_FILES, SUB_HEADER_FORMS} from '../../redux/config/reqListConfig';
import {FormRequirementItem} from '../FormRequirementItem';
import {RequirementItem} from '../RequirementItem';


function BaseRequirementListView(props) {
  return (
    <List
      className={classNames("RequirementList", props.className, {
        RequirementList__minimalView: props.minimalView,
      })}
      useScroll={props.useScroll}
      useAnimation={false}
      flipped={false}
      autoScroll={false}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
      transitionGroupClass={props.transitionGroupClass}
    >
      {props.list ? props.list.map(model => renderItem(props, model)) : null}
    </List>
  );
}

function renderItem(props, model) {
  const modelId = getId(model);
  if (modelId === SUB_HEADER_FORMS) {
    return (
      <ListDivider
        label={props.formsHeader}
      />
    );
  } else if (modelId === SUB_HEADER_FILES) {
    return (
      <ListDivider
        label={props.filesHeader}
      />
    );
  }

  switch (getCollection(model)) {
    case ASSET_FILE_REQUIREMENT_COLLECTION:
    case FILE_REQUIREMENT_COLLECTION:
      return (
        <RequirementItem
          key={modelId}
          className={getItemClass(model)}
          itemClassName={props.itemClassName}
          itemId={modelId}
          init={props.init}
          userId={props.userId}
          model={model}
          onClick={props.onClickItem}
          onContextMenu={props.onItemContextMenu}
          showCameraButton={props.showCameraButton}
          showVideoButton={props.showVideoButton}
          isCameraButtonEnabled={props.isCameraButtonEnabled}
          isVideoButtonEnabled={props.isVideoButtonEnabled}
          onCameraButtonClick={props.onCameraButtonClick}
          onVideoButtonClick={props.onVideoButtonClick}
          showUploadButton={props.showUploadButton}
          isUploadButtonEnabled={props.isUploadButtonEnabled}
          onUploadButtonClick={props.onUploadButtonClick}
          showIOSUpButton={props.showIOSUpButton}
          isUpIOSButtonEnabled={props.isUpIOSButtonEnabled}
          onUpIOSButtonClick={props.onUpIOSButtonClick}
          isFileSelectEnabled={props.isFileSelectEnabled}
          onFileSelect={props.onFileSelect}
          onFileSelectDenied={props.onFileSelectDenied}
          enableSwipeout={props.viewWidth < 680 /* Match Sass variable $break-medium */}

          {...getMessagesFromProps(props, RequirementItem.messageProps)}
        />
      );
    case ASSET_FORM_REQUIREMENT_COLLECTION:
    case FORM_REQUIREMENT_COLLECTION:
      return (
        <FormRequirementItem
          key={modelId}
          className={classNames(props.itemClassName, getItemClass(model))}
          init={props.init}
          userId={props.userId}
          model={model}
          onClick={props.onClickItem}
          onContextMenu={props.onItemContextMenu}
        />
      );
    default:
      return null;
  }
}

BaseRequirementListView.propTypes = {
  className: T.string,
  transitionGroupClass: T.string,
  itemClassName: T.string,
  minimalView: T.bool,
  task: T.object,
  viewWidth: T.number.isRequired,
  itemComponent: T.any,

  enableSwipeout: T.bool,
  onClickItem: T.func,
  onItemContextMenu: T.func,
  showCameraButton: T.bool,
  showVideoButton: T.bool,
  isCameraButtonEnabled: T.func,
  isVideoButtonEnabled: T.func,
  onCameraButtonClick: T.func,
  onVideoButtonClick: T.func,
  showUploadButton: T.bool,
  isUploadButtonEnabled: T.func,
  onUploadButtonClick: T.func,
  showIOSUpButton: T.bool,
  isUpIOSButtonEnabled: T.func,
  onUpIOSButtonClick: T.func,
  isFileSelectEnabled: T.func,
  onFileSelect: T.func,
  onFileSelectDenied: T.func,

  formsHeader: T.string,
  filesHeader: T.string,

  init: T.bool,
};

BaseRequirementListView.defaultProps = {
  init: true,
};

export const RequirementListView = I18nComponent(responsiveContent(BaseRequirementListView), [
  {code: 'requirements.list.forms.header', prop: 'formsHeader'},
  {code: 'requirements.list.files.header', prop: 'filesHeader'},
  ...RequirementItem.messages,
]);



// WEBPACK FOOTER //
// ./src/js/requirements/components/RequirementList/RequirementListView.js